import { CommonModule } from '@angular/common';
import { Component, effect, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { InputComponent } from '../../../../../../shared/components/input/input.component';
import { TextareaComponent } from '../../../../../../shared/components/textarea/textarea.component';
import { AppService } from '../../../../services/app.service';
import { AuthService } from 'app/features/auth/services/auth.service';
import { environment } from '@env/environment';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  standalone: true,
  selector: 'edit-side-menu',
  imports: [
    CommonModule,
    MultiSelectModule,
    DropdownModule,
    AutoCompleteModule,
    FormsModule,
    ReactiveFormsModule,
    InputComponent,
    TextareaComponent,
    SkeletonModule,
  ],
  templateUrl: './edit-side-menu.component.html',
  styleUrl: './edit-side-menu.component.scss',
  animations: [
    trigger('fadeSlide', [
      state('void', style({ opacity: 0, transform: 'translateY(20px)' })),
      state('*', style({ opacity: 1, transform: 'translateY(0)' })),
      transition('void => *', animate('400ms ease-out')),
      transition('* => void', animate('300ms ease-in')),
    ]),
  ],
})
export class EditSideMenuComponent implements OnInit {
  // type = this.router.url.split('/')[2];
  type: string = '';
  title: string = '';
  values: any;
  signal_value: any;
  form!: FormGroup;

  currentSkill: string | null = '';
  skills: string[] = [];
  filteredSkills: string[] = [];
  countries: any[] = [];
  cities: any[] = [];
  isLoading = false;
  categories: any[] = [];
  levels = ['basic', 'intermediate', 'advanced', 'native'];
  langs: any[] = []; // اللغات الجاية من الـ API
  selectedLanguages: { id: number; name: string; level: string | null }[] = [];
  profile_image_url: string | null = null;
  imageSize: string | null = null;
  maxSkillChars = 50;
  remainingChars = this.maxSkillChars;
  constructor(
    private router: Router,
    public service: ProfileService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private app_service: AppService,
    private authService: AuthService
  ) {
    effect(() => {
      this.signal_value = this.service.isOpened();
      if (this.signal_value.title != null) {
        switch (this.signal_value.title) {
          case 'photo': {
            this.title = 'Profile photo';
            this.form = this.formBuilder.group({
              profile_picture: [
                this.signal_value.values.profile_image || null,
                Validators.required,
              ],
            });
            // console.log("profile_picture",this.signal_value.values.profile_picture)
            this.profile_image_url = this.signal_value.values.profile_picture;
            console.log('profile_image_url', this.profile_image_url);

            break;
          }

          case 'intro': {
            this.title = 'Edit Intro';
            // if(this.type == 'freelancer') {
            this.form = this.formBuilder.group({
              name: [
                this.signal_value.values.name || null,
                [
                  Validators.required,
                  Validators.pattern(
                    /^(?=.{3,50}$)[A-Za-z\u0600-\u06FF]+(?: [A-Za-z\u0600-\u06FF]+)*$/
                  ),
                ],
              ],
              headline: [this.signal_value.values.headline || null, Validators.required],
            });
            this.form.get('headline')?.markAsTouched();
            // }
            // else{
            //   this.form = this.formBuilder.group({
            //     name: [(this.signal_value.values.name || null), [Validators.required  , Validators.pattern(/^(?=.{3,50}$)[A-Za-z\u0600-\u06FF]+(?: [A-Za-z\u0600-\u06FF]+)*$/)]],
            //   })
            // }
            break;
          }

          case 'about': {
            this.title = 'Bio';
            this.form = this.formBuilder.group({
              about_me: [
                this.signal_value.values || null,
                [Validators.required, Validators.maxLength(5000), Validators.minLength(200)],
              ],
            });
            break;
          }

          case 'skills': {
            this.title = 'Skills';
            this.form = this.formBuilder.group({
              skills: [
                this.signal_value.values.map((item: any) => item.name) || null,
                Validators.required,
              ],
            });
            this.allSkills();
            break;
          }

          case 'basic_info': {
            this.title = 'Basic information';
            if (this.type == 'client') {
              this.form = this.formBuilder.group({
                company: [
                  this.signal_value.values.company !== 'null' &&
                  this.signal_value.values.company !== null
                    ? this.signal_value.values.company
                    : null,
                ],
                country: [this.signal_value.values.country?.id || null, Validators.required],
                city: [this.signal_value.values.city?.id || null, Validators.required],
              });
            } else if (this.type == 'freelancer') {
              this.form = this.formBuilder.group({
                // headline: [
                //   this.signal_value.values.headline || '',
                //   Validators.required,
                // ],
                category_id: [this.signal_value.values.category?.id || null, Validators.required],
                country: [this.signal_value.values.country?.id || null, Validators.required],
                city: [this.signal_value.values.city?.id || null, Validators.required],
              });
            }

            if (this.form) {
              this.allCountries();
              this.allCategories();
            }
            break;
          }
          case 'languages': {
            this.title = 'Language';

            this.form = this.formBuilder.group({
              languages: this.formBuilder.array([]),
            });

            if (this.signal_value.values?.length) {
              this.signal_value.values.forEach((lang: any) => {
                this.selectedLanguages.push({
                  id: lang.id,
                  name: lang.name,
                  level: lang.level,
                });
              });
            }
            this.languages.push(this.createLanguageGroup());
            this.allLanguages();
            break;
          }
        }
      }

      this.type = this.service.profileType();
    });
  }

  ngOnInit(): void {}

  allCategories() {
    this.app_service.getCategories().subscribe((res: any) => {
      this.categories = res?.data;
    });
  }

  onCountryChange(countryName: string, flag: boolean) {
    this.service.getCitiesByCountry(countryName).subscribe((res: any) => {
      this.cities = res.data;
      if (!this.form) return;
      if (flag == true) {
        console.log(this.signal_value.values.city.id);

        this.form.patchValue({ city: this.signal_value.values.city.id });
      } else {
        this.form.patchValue({ city: null });
      }
    });
  }

  allCountries() {
    this.isLoading = true;
    this.service.getCountries().subscribe((res: any) => {
      this.countries = res.data;
      console.log(res);
      this.isLoading = false;
      if (this.signal_value?.values?.country) {
        this.onCountryChange(this.signal_value?.values?.country?.id, true);
      }
    });
  }

  uploadProfileImage() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/JPEG,image/JPG,image/PNG,image/HEIC,image/WEBP';

    input.onchange = (event: any) => {
      const file: File = event.target.files[0];
      if (file) {
        const validTypes = ['image/jpeg', 'image/png', 'image/heic', 'image/jpg', 'image/webp'];
        if (!validTypes.includes(file.type)) {
          this.toastr.error('Please upload a valid image (jpg,png,heic,jpeg)');
          return;
        }

        const maxSize = 2 * 1024 * 1024;
        if (file.size > maxSize) {
          this.toastr.error('Profile picture must be less than 2MB', 'Error');
          return;
        }

        this.form.patchValue({ profile_picture: file });

        const reader = new FileReader();
        reader.onload = () => {
          this.profile_image_url = reader.result as string;
        };
        reader.readAsDataURL(file);

        const sizeInKB = (file.size / 1024).toFixed(1);
        const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
        this.imageSize = file.size < 1024 * 1024 ? `${sizeInKB} KB` : `${sizeInMB} MB`;
      }
    };

    input.click();
  }

  get languages(): FormArray {
    return this.form.get('languages') as FormArray;
  }

  allLanguages() {
    this.service.getLanguages().subscribe((res: any) => {
      this.langs = res?.data || [];
      this.filterAvailableLanguages(); // ✅ فلترة عند التحميل
    });
  }

  createLanguageGroup(
    language_id: number | null = null,
    language_level: any | null = null
  ): FormGroup {
    const group = this.formBuilder.group({
      language_id: [language_id],
      language_level: [language_level],
    });

    return group;
  }

  addLanguage() {
    this.languages.push(this.createLanguageGroup());
  }

  removeLanguage(index: number) {
    this.languages.removeAt(index);
  }

  addNewLang(index: number) {
    const group = this.languages.at(index) as FormGroup;
    const { language_id, language_level } = group.value;

    if (language_id && language_level) {
      // ✅ تحقق لو اللغة دي مضافة بالفعل
      const alreadyExists = this.selectedLanguages.some((lang) => lang.id === language_id);
      if (alreadyExists) {
        this.toastr.warning('This language has already been added');
        return;
      }

      this.upsertLanguage(language_id, language_level);

      // ✅ بعد الإضافة، اعملي فلترة للغات
      this.filterAvailableLanguages();

      group.reset(
        {
          language_id: null,
          language_level: null,
        },
        { emitEvent: false }
      );
    }
  }

  filterAvailableLanguages() {
    const selectedIds = this.selectedLanguages.map((lang) => lang.id);
    this.langs = this.langs.filter((lang) => !selectedIds.includes(lang.id));
  }

  deleteLanguage(language_id: number, language_level: any) {
    this.selectedLanguages = this.selectedLanguages.filter(
      (l) => !(l.id === language_id && l.level === language_level)
    );

    const index = this.languages.controls.findIndex(
      (c) => c.value.language_id === language_id && c.value.language_level === language_level
    );

    if (index > -1) {
      this.languages.at(index).patchValue(
        {
          language_id: null,
          language_level: null,
        },
        { emitEvent: false }
      );
    }

    // ✅ رجّع اللغة دي لقائمة الاختيار
    this.allLanguages();
    this.filterAvailableLanguages();
  }

  upsertLanguage(language_id: number, language_level: any) {
    const langName = this.langs.find((s) => s.id === language_id)?.name || '';
    const levelName: any = this.levels.find((l: any) => l === language_level) || '';

    this.selectedLanguages.push({
      id: language_id,
      name: langName,
      level: levelName,
    });
  }

  close() {
    this.service.changeEditStatus({
      type: this.type,
      status: false,
      title: null,
      values: null,
    });
  }

  get f(): any {
    return this.form.controls;
  }

  allSkills() {
    this.service.getSkills().subscribe((res: any) => {
      this.skills = res?.data?.map((s: any) => s.name) || [];
      this.filteredSkills = [...this.skills];
    });
  }
  onEnterSkill(event: any) {
    console.log(event?.target?.value);

    this.currentSkill = event?.target?.value ?? '';
  }
  onAboutChange(value: string) {
    this.remainingChars = this.maxSkillChars - (value?.length || 0);
  }
  onSelectSkill(event: any) {
    console.log(event);

    this.currentSkill = event?.value ?? '';
  }
  onInput(event: any) {
    this.currentSkill = event.target.value;
  }

  search(event: any) {
    const query = (event.query || '').toLowerCase();

    this.filteredSkills = this.skills.filter(
      (skill) => skill.toLowerCase().includes(query) && !this.selectedSkills.includes(skill)
    );

    // لو كتب مهارة جديدة مش موجودة
    if (query && !this.skills.some((s) => s.toLowerCase() === query)) {
      this.filteredSkills.unshift(event.query);
    }
  }

  @ViewChild('auto') auto!: AutoComplete;
  onSkillFocus() {
    console.log('---------------->');
    if (!this.currentSkill) {
      this.filteredSkills = [];
      setTimeout(() => {
        this.auto.show();
      });
    }
  }
  addSkill() {
    const skill = this.currentSkill?.trim();
    if (!skill) return;

    const current = this.selectedSkills;

    if (!current.includes(skill)) {
      this.form.patchValue({
        skills: [...current, skill],
      });
    }

    // ✅ يفضّي الـ input ويرجّع placeholder
    this.currentSkill = null;
    this.auto.clear();
  }

  removeSkill(skill: string) {
    const updated = this.selectedSkills.filter((s) => s !== skill);
    this.form.patchValue({ skills: updated });
  }

  get selectedSkills(): string[] {
    return this.form.value.skills || [];
  }

  save() {
    let payload: any = {};

    if (this.title === 'Language') {
      if (this.selectedLanguages.length > 0) {
        payload = {
          languages: this.selectedLanguages.map((lang, index) => ({
            language_id: lang.id,
            language_level: lang.level,
          })),
        };
      } else {
        payload = { languages: [] };
      }
    } else if (this.title == 'Skills') {
      payload = {
        skills: this.selectedSkills,
      };
    } else if (this.title == 'Basic information') {
      const company =
        this.signal_value.values.company == 'null' ? null : this.signal_value.values.company;
      console.log(company);

      if (this.type !== 'freelancer' && company !== null && company !== 'null') {
        this.form.get('company')?.setValidators([Validators.required]);
      } else {
        // مهم جدًا تشيلي الـ validator لما الشرط مش متحقق
        this.form.get('company')?.clearValidators();
      }

      this.form.get('company')?.updateValueAndValidity();

      if (this.form.invalid) {
        return;
      }

      payload = { ...this.form.value };
    } else {
      payload = { ...this.form.value };
    }

    this.service.sendProfile(payload).subscribe(
      (res: any) => {
        this.toastr.success(res?.message);
        this.service.changeEditStatus({
          type: this.type,
          status: false,
          title: null,
          values: null,
        });
        this.service.refreshDataObj(res?.data);
        // ✅ Update the current user with new profile data
        const currentUser = this.authService.currentUserValue;
        if (currentUser?.user) {
          currentUser.user = { ...currentUser.user, ...res?.data };
          this.authService.currentUserSubject.next(currentUser);
        }
        localStorage.setItem(environment.currentUserKey, JSON.stringify(currentUser));
      },
      (err: any) => {
        this.toastr.error(err?.error?.message);
      }
    );
  }

  isSaveDisabled(): boolean {
    if (this.form.invalid) {
      return true;
    }

    switch (this.signal_value.title) {
      case 'skills':
        return this.selectedSkills.length === 0;

      case 'languages':
        return this.selectedLanguages.length === 0;

      case 'intro':
        return !this.form.get('name')?.value || !this.form.get('headline')?.value;

      case 'about':
        return !this.form.get('about_me')?.value;

      case 'basic_info':
        if (this.type === 'freelancer') {
          return (
            !this.form.get('country')?.value ||
            !this.form.get('city')?.value ||
            !this.form.get('category_id')?.value
          );
        }

        return (
          !this.form.get('company')?.value ||
          !this.form.get('country')?.value ||
          !this.form.get('city')?.value
        );

      case 'photo':
        return !this.profile_image_url;

      default:
        return true;
    }
  }
}
